import React, { Component } from 'react';
import { node, shape, string, number } from 'prop-types';
import { Radio } from 'informed';
import ControlSideLabel from '../controlSideLabel';

import classify from '@magento/venia-ui/lib/classify';
import defaultClasses from './radio.module.css';

import Image from '../../components/Image';
import { Price } from '../../peregrine';

/* TODO: change lint config to use `label-has-associated-control` */
/* eslint-disable jsx-a11y/label-has-for */

export class RadioOption extends Component {
    static propTypes = {
        classes: shape({
            input: string,
            label: string,
            root: string,
            demo: string,
            price: string
        }),
        label: node.isRequired,
        value: node.isRequired,
        color: string,
        thumb: string,
        price: number
    };

    render() {
        const { props } = this;
        const {
            classes,
            label,
            value,
            color,
            price,
            priceBy = null,
            displayPrice,
            radioGroupName = null,
            thumb,
            image,
            infoBlock,
            after,
            onClick,
            ...rest
        } = props;

        const thumbUrl = thumb
            ? thumb.match(/^http/)
                ? thumb
                : process.env.MAGENTO_BACKEND_URL + thumb
            : null;
        const imageUrl = image
            ? image.match(/^http/)
                ? image
                : process.env.MAGENTO_BACKEND_URL + image
            : null;

        const styles = {};
        color && (styles.backgroundColor = color);
        /*
		container: string,
        loaded: string,
        notLoaded: string,
        root: string*/

        if (!value) {
            //debugger;
            console.error('No value defined for this radiobutton', this);
        }

        const isControlSide =
            radioGroupName.startsWith('controlSide') &&
            value != 'left' &&
            value != 'right';

        const child =
            thumb || image ? (
                <>
                    {isControlSide ? <ControlSideLabel label={label} /> : null}
                    <Image
                        resource={thumbUrl || imageUrl}
                        width={150}
                        height={150}
                        alt={label}
                        ratio={1}
                        padding={0}
                        classes={{ container: classes.demo }}
                    />
                </>
            ) : (
                <span className={classes.demo} style={styles} />
            );

        const id = `radio-${radioGroupName}-${value}`;

        const priceToDisplay = displayPrice > 0 ? displayPrice : price;

        const priceBlock =
            price > 0 ? (
                <span className={classes.price}>
                    <Price value={priceToDisplay} currencyCode="EUR" />
                    {priceBy ? _('/m') : null}
                </span>
            ) : price != 0 ? (
                <span className={classes.price}>{priceToDisplay}</span>
            ) : null;

        const labelClasses = [
            classes.root,
            isControlSide ? classes.controlside : null,
            thumb || image ? classes.withimage : null
        ].filter(item => !!item);

        return (
            <label
                className={labelClasses.join(' ')}
                htmlFor={id}
                onClick={onClick}
            >
                <Radio
                    {...rest}
                    className={classes.input}
                    id={id}
                    value={value}
                />
                {child}
                {isControlSide ? (
                    after
                ) : (
                    <span
                        className={classes.label}
                        dangerouslySetInnerHTML={{
                            __html: label || (value != null ? value : '')
                        }}
                    />
                )}
                {priceBlock}
                {infoBlock}
            </label>
        );
    }
}

/* eslint-enable jsx-a11y/label-has-for */

export default classify(defaultClasses)(RadioOption);
